import {
  GET_CHALLENGES,
  GET_CHALLENGES_SUCCESS,
  GET_CHALLENGES_ERROR,
  GET_MY_COHORTS,
  GET_MY_COHORTS_SUCCESS,
  GET_MY_COHORTS_ERROR,
} from './constants';

const initialState = {
  challenges: [],
  challengesLoading: false,
  challengesError: null,
  myCohorts: [],
  myCohortsLoading: false,
  myCohortsError: null,
};

function challenge(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_CHALLENGES:
      return {
        ...state,
        challengesError: null,
        challengesLoading: true,
      };
    case GET_CHALLENGES_SUCCESS:
      return {
        ...state,
        challenges: payload,
        challengesLoading: false,
      };
    case GET_CHALLENGES_ERROR:
      return {
        ...state,
        challengesLoading: false,
        challengesError: action.err,
      };
    case GET_MY_COHORTS:
      return {
        ...state,
        myCohortsError: null,
        myCohortsLoading: true,
      };
    case GET_MY_COHORTS_SUCCESS:
      return {
        ...state,
        myCohorts: payload,
        myCohortsLoading: false,
      };
    case GET_MY_COHORTS_ERROR:
      return {
        ...state,
        myCohortsLoading: false,
        myCohortsError: action.err,
      };
    default:
      return state;
  }
}

export default challenge;
